import React from 'react';
import PropTypes from 'prop-types';

const FooterContent = (props) => {
    const {content} = props;

    return (
        <ul className="footer-content-outer-container" role="list">
            {content.map((section, sectionIndex) => (
                <li
                    key={sectionIndex}
                    className="footer-content-inner-container"
                    role="listitem"
                >
                    <h3 className="footer-content-section-title">
                        {section.title}
                    </h3>
                    <ul
                        className="footer-content-section-outer-container"
                        role="list"
                    >
                        {section.content.map(({url, text}, linkIndex) => (
                            <li
                                key={linkIndex}
                                className="footer-content-section-inner-container"
                                role="listitem"
                            >
                                <div className="footer-content-section-redirect-link-outer">
                                    <a
                                        aria-label="List your property"
                                        href={url}
                                        target="_self"
                                        className="footer-content-section-redirect-link"
                                        role="link"
                                    >
                                        {text}
                                    </a>
                                </div>
                            </li>
                        ))}
                    </ul>
                </li>
            ))}
        </ul>
    );
};

FooterContent.propTypes = {
    content: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string,
            content: PropTypes.arrayOf(
                PropTypes.shape({
                    url: PropTypes.string,
                    text: PropTypes.string,
                })
            ),
        })
    ).isRequired,
};

export default FooterContent;
